import React from 'react';

// Still paper grain with a faint vignette, like a printed page
function Paper() {
  return (
    <>
      <div className="paper-grain" />
      <div className="paper-vignette" />
    </>
  );
}

export default Paper;
